import React from 'react';

const TaveelLogo = ({ className = "w-10 h-10", animated = false }) => {
  return (
    <svg
      viewBox="0 0 100 100"
      className={`${className} ${animated ? 'animate-logo-scale' : ''}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Outer hexagon shape */}
      <path
        d="M 50 5 L 85 27.5 L 85 72.5 L 50 95 L 15 72.5 L 15 27.5 Z"
        fill="url(#gradient1)"
        stroke="#10B981"
        strokeWidth="2"
      />
      
      {/* Stylized T letter */}
      <g fill="#FFFFFF">
        {/* Top bar of T */}
        <rect x="30" y="30" width="40" height="8" rx="2" />
        {/* Vertical bar of T */}
        <rect x="46" y="30" width="8" height="40" rx="2" />
      </g>
      
      {/* Gradient definition */}
      <defs>
        <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#10B981" stopOpacity="0.3" />
          <stop offset="100%" stopColor="#1F2937" stopOpacity="0.4" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default TaveelLogo;
